import type { RouteRecordRaw } from "vue-router";

import { PageNotFoundPage } from "@vm/vue-core";

export default [
  {
    path: "/:catchAll(.*)",
    component: PageNotFoundPage,
  },
] as RouteRecordRaw[];
